import React, { useEffect, useState } from "react";
import RichTextEditor from "../../Component/RichTextEditor";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  fetchTermsAndConditions,
  updateTermsAndConditions,
} from "../../Services/privacy_policy";
import { Spin } from "antd";

const TermsAndCondition = () => {
  const [editorContent, setEditorContent] = useState("");

  const { data, isLoading } = useQuery({
    queryKey: ["TermsandConditions"],
    queryFn: fetchTermsAndConditions,
    refetchOnWindowFocus: false,
    retry: false,
  });

  const mutation = useMutation({
    mutationFn: updateTermsAndConditions,
    onSuccess: (updatedData) => {
      setEditorContent(updatedData?.value || "");
    },
  });

  const handleEditorSubmit = (content) => {
    mutation.mutate({ value: content });
  };

  useEffect(() => {
    if (data?.length) {
      setEditorContent(data[0]?.value);
    }
  }, [data]);
  return (
    <div>
      <h3>Terms And Conditions</h3>
      <Spin spinning={isLoading}>
        <RichTextEditor
          initialValue={editorContent}
          onSubmit={handleEditorSubmit}
          loading={mutation?.isPending}
        />
      </Spin>
    </div>
  );
};

export default TermsAndCondition;
